module.exports = __webpack_public_path__ + "img/bookshelf_right.fb018092.png";